import { createAction, props } from '@ngrx/store';

import { AddToCartEvent } from '../../models/events/add-to-cart.model';
import { ZenitList, ZenitEventData } from '../../models/zenit-general.model';

import { CartItem } from '@api/cart/cart.models';
import { Product } from '@api/catalog/products/products.models';
import { EmpathySearcherOrigin } from '@core/domain/types/empathy-searcher-origin.type';
import { SearchType } from '@features/search/domain/models/search.models';
import { EventFrom } from '@shared/analytics/COMMON/models/analytics-common.models';
import { ProductViewPlace } from '@shared/product/related-products/domain/models/related-products.models';

const ZenitActionTypes = {
    ADD_TO_CART_EVENT: '[zenit] ADD_TO_CART_EVENT',
    CLEAR_VIEWED_PRODUCTS: '[zenit] CLEAR_VIEWED_PRODUCTS',
    IMPRESSIONS_HIT_EVENT: '[zenit] IMPRESSIONS_HIT_EVENT',
    LIST_ITEM_VISIBLE: '[zenit] LIST_ITEM_VISIBLE',
    PAGE_HIT_EVENT: '[zenit] PAGE_HIT_EVENT',
    SELECT_ITEM: '[zenit] SELECT_ITEM',
    SET_ORIGIN_ITEM_LIST: '[zenit] SET_ORIGIN_ITEM_LIST',
    SET_ORIGIN_ITEM_LIST_ERROR: '[zenit] SET_ORIGIN_ITEM_LIST_ERROR',
    ZENIT_EVENT_ERROR: '[zenit] ZENIT_EVENT_ERROR',
    ZENIT_EVENT_SUCCESS: '[zenit] ZENIT_EVENT_SUCCESS',
};

export const ZenitPageHitEventAction = createAction(
    ZenitActionTypes.PAGE_HIT_EVENT,
    props<{ eventFrom?: EventFrom; eventData?: ZenitEventData }>()
);

export const ZenitAddToCartEvent = createAction(
    ZenitActionTypes.ADD_TO_CART_EVENT,
    props<{ addToCartEvent: AddToCartEvent }>()
);

export const ZenitSelectItem = createAction(
    ZenitActionTypes.SELECT_ITEM,
    props<{
        eventFrom: EventFrom;
        item?: CartItem | Product;
        place?: ProductViewPlace;
        relatedsSectionId?: string;
        searchOrigin?: EmpathySearcherOrigin | SearchType;
    }>()
);

export const ZenitSetOriginItemList = createAction(
    ZenitActionTypes.SET_ORIGIN_ITEM_LIST,
    props<{
        originItemEventFrom: EventFrom;
        originItemListIndex: number;
        originItemListName: ZenitList;
        originItemRelatedType: EventFrom;
    }>()
);

export const ZenitSetOriginItemListError = createAction(
    ZenitActionTypes.SET_ORIGIN_ITEM_LIST_ERROR,
    props<{ error: any }>()
);

export const ZenitListItemVisible = createAction(
    ZenitActionTypes.LIST_ITEM_VISIBLE,
    props<{ product: Product; eventFrom: EventFrom; relatedsSectionId: string; place: ProductViewPlace }>()
);

export const ImpressionsHitEventAction = createAction(
    ZenitActionTypes.IMPRESSIONS_HIT_EVENT,
    props<{ products: Product[]; eventFrom: EventFrom; relatedsSectionId: string; place: ProductViewPlace }>()
);

export const ZenitClearViewedProducts = createAction(
    ZenitActionTypes.CLEAR_VIEWED_PRODUCTS,
);

export const ZenitEventSuccess = <T>() => createAction(
    ZenitActionTypes.ZENIT_EVENT_SUCCESS,
    props<{ eventData: T }>()
);

export const ZenitEventError = createAction(
    ZenitActionTypes.ZENIT_EVENT_ERROR,
    props<{ error: unknown }>()
);
